module.exports = __webpack_public_path__ + "img/HUF.99aba35f.svg";